
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorComingFrom as ObiConnectorComingFromElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-coming-from.js';
 
 
 

 
 export const ObiConnectorComingFrom = createComponent({
   react: React,
   tagName: 'obi-connector-coming-from',
   elementClass: ObiConnectorComingFromElement,
   events: {
     
   }
  });
 
 